import React from 'react';
import styled from 'styled-components';

const ArrowWrapper = styled.div({
    backgroundColor: props => props.containerColor,
    height: '2.2rem',
    border: 0,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    padding: 5,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
});
const ArrowDown = props => (
    <ArrowWrapper style={props.containerStyle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15px"
            height="15px"
            viewBox="0 0 255 255"
            color={props.color}
        >
            <g>
                <g id="arrow-drop-down">
                    <polygon points="0,63.75 127.5,191.25 255,63.75 		" />
                </g>
            </g>
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
        </svg>
    </ArrowWrapper>
);

export { ArrowDown };
